import * as React from "react";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import { EnterprisePluginNotFound } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import EditLinkButton from "./EditLinkButton";
import { STEP_KEY as GROUP_SYNC_KEY } from "../BackendWizard/GroupSyncStep";
const GroupSyncSection = ({ authenticationBackend, roles, excludedFields = void 0 }) => {
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const GroupSyncSectionPlugin = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.components.GroupSyncSection;
  if (!GroupSyncSectionPlugin) {
    return /* @__PURE__ */ React.createElement(
      SectionComponent,
      {
        title: "Group Synchronization",
        headerActions: /* @__PURE__ */ React.createElement(EditLinkButton, { authenticationBackendId: authenticationBackend.id, stepKey: GROUP_SYNC_KEY })
      },
      /* @__PURE__ */ React.createElement(EnterprisePluginNotFound, { featureName: "group synchronization" })
    );
  }
  return /* @__PURE__ */ React.createElement(
    GroupSyncSectionPlugin,
    {
      authenticationBackend,
      excludedFields,
      roles
    }
  );
};
export default GroupSyncSection;
